// src/components/productPage/singleProductPageComponents/ysim/types.ts

import type { ChartData, ScaleOptions } from 'chart.js';
import { ProductsContent } from '../../../../graphql/pimcore/modules/siteContent/types/ProductsContent';

export interface KsimPlotProps {
    partNumber: string;
    contentTree: ProductsContent;
}

export interface VbiasValue {
    vbias: number;
    capacitance_change_percent: number;
}
export interface TccValue {
    temperature: number;
    capacitance_change_percent: number;
}
export interface VcacValue {
    vcac: number;
    capacitance_change_percent: number;
}
export interface RippleCurrent {
    temperature: number;
    current: number;
}
export interface FrequencyValue {
    frequency: number;
    impedance: number;
    esr: number;
    capacitance: number;
    inductance: number;
    current: number | undefined;
    voltage: number | undefined;
    s11_magnitude: number | undefined;
    s11_phase: number | undefined;
    s21_magnitude: number | undefined;
    s21_phase: number | undefined;
    q: number | undefined;
}
export interface ApiResponse {
    part_number: string;
    freq_min: number;
    freq_max: number;
    ambient_temp_c: string;
    cap_temp_rise_c: string;
    ripple_current: Record<string, RippleCurrent[]> | null;
    frequency_values: FrequencyValue[];
    vbias_values: VbiasValue[];
    tcc_values: TccValue[] | null;
    vcac_values: VcacValue[] | null;
}

export interface ChartDatasetWithAxis {
    label: string;
    altLabel?: string;
    data: ({ x: number; y: number | undefined } | null)[];
    borderColor?: string;
    backgroundColor?: string;
    fill: boolean;
    tension: number;
    yAxisID?: string;
}

export interface KsimState {
    allDatasets: ChartDatasetWithAxis[];
    plotData: ChartData<'line'>;
    selectedDatasets: string[];
    loading: boolean;
    error: string | null;
}

export type AxisScale = ScaleOptions<'linear' | 'logarithmic'>;

export const LABELS = {
    TCC: 'Capacitance Change Vs Temperature',
    VCAC: 'Capacitance Change Vs AC Voltage',
    VBIAS: 'Capacitance Change Vs Bias Voltage',
    RIPPLE: 'Ripple Current',
} as const;

export const S_PARAM_LABELS = [
    'S11 Magnitude',
    'S11 Phase (Degrees)',
    'S21 Magnitude',
    'S21 Phase (Degrees)',
] as const;

export const DEFAULT_SELECTED = ['Impedance (Ohms)', 'ESR (Ohms)'];
